export default __webpack_public_path__ + "maps-examples-default-callout-960-3e5bf1092ca9546761c7e2cb81b4038b.png";